import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../../components/layout';
import SEO from '../../components/seo';

export default function NeverGonnaGiveYouUp() {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        totalCount
      }
    }
  `);
  const totalEpisodes = data.allEpisodesJson.totalCount;

  return (
    <Layout>
      <SEO title="dQw4w9WgXcQ - Rick Astley" />
      <div className="mt-40 max-w-xl">
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            src={`https://www.youtube-nocookie.com/embed/dQw4w9WgXcQ?autoplay=1&modestbranding=1&rel=0`}
            title="YouTube video player"
            width="380"
            height="210"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen="1"
            loading="lazy"
          ></iframe>
        </div>
        <details className="mt-8">
          <summary></summary>
          <p>
            Congratulations! You've found a very special page.
            <br /> You had 1 in {totalEpisodes} (
            {(1 / totalEpisodes).toFixed(3)}
            %) chance of stumbling here.
          </p>
        </details>
      </div>
    </Layout>
  );
}
